// This file is automatically generated. Do not edit it directly.
import { createClient } from '@supabase/supabase-js';
import type { Database } from './types';

const SUPABASE_URL = "https://pxurtuktvoeaytlozzue.supabase.co";
const SUPABASE_PUBLISHABLE_KEY = "eyJhbGciOiJIUzI1NiIsInR5cCI6IkpXVCJ9.eyJpc3MiOiJzdXBhYmFzZSIsInJlZiI6InB4dXJ0dWt0dm9lYXl0bG96enVlIiwicm9sZSI6ImFub24iLCJpYXQiOjE3NTA3MTE0NDQsImV4cCI6MjA2NjI4NzQ0NH0.S51PvLijHgZFEOeTfInq_V19A8XFJzDaaUdFw0ebunA";

// Import the supabase client like this:
// import { supabase } from "@/integrations/supabase/client";

export const supabase = createClient<Database>(SUPABASE_URL, SUPABASE_PUBLISHABLE_KEY);